import React from "react";
import {Wrapper} from "./EventTimer.styled";
import {useTimer} from "../../../../logic/core/timer.hook";
import {useTranslation} from "react-i18next";

const EventTimer = ({
    startDate,
    finishDate,
    finishedAt
}: {
    startDate?: Date | null;
    finishDate?: Date | null;
    finishedAt?: Date | null;
}) => {
    const {t, i18n} = useTranslation('common');
    const isFutureStart = Boolean(!finishDate && startDate && new Date(startDate).getTime() > Date.now());
    const isCountdown = Boolean(finishDate || isFutureStart);
    const targetDate = finishDate ?? startDate ?? null;
    const [days, hours, minutes, seconds, timeRemaining] = useTimer(targetDate, isCountdown);

    if (finishedAt) {
        return (
            <Wrapper>
                <div className="timer finished">
                    {t('eventAgenda.votingFinished', {
                        date: new Intl.DateTimeFormat(i18n.language, {
                            dateStyle: 'short',
                            timeStyle: 'short',
                        }).format(new Date(finishedAt)),
                    })}
                </div>
            </Wrapper>
        );
    }

    if (!targetDate) {
        return null;
    }

    const isUrgent = !!finishDate && typeof timeRemaining === 'number' && timeRemaining > 0 && timeRemaining < 24 * 60 * 60 * 1000;
    const formattedTime = `${days !== '00' ? `${parseInt(days as string, 10)}d ` : ''}${hours !== '00' || days !== '00' ? `${hours}:` : ''}${minutes}:${seconds}`;

    const renderContent = () => {
        if (finishDate) {
            return t('eventAgenda.votingTimeLeft', { time: formattedTime });
        }
        if (isFutureStart) {
            return t('eventAgenda.votingStartsIn', { time: formattedTime });
        }
        return formattedTime;
    };

    return (
        <Wrapper>
            <div className={`timer ${isUrgent ? 'urgent' : ''}`}>
                {renderContent()}
            </div>
        </Wrapper>
    );
};

export default EventTimer;
